import styled from 'styled-components';

export const ContactContainer = styled.div`
  text-align: center;
  padding: 20px;
  border: 1px solid #ff0359;
  background-color: #fcdce7;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 35px;
`;
export const Title = styled.h1`
  color: #333333;
`;

export const Subtitle = styled.h3`
  color: #333333;
  text-align: left;
`;